import { Flex } from "@chakra-ui/layout";
import styled from "styled-components";

const StyledDot = styled.span.attrs((props: any) => ({
        ativo: props.ativo || false
    }))`
        height: 20px;
        width: 20px;        
        border-radius: 50%;
        display: inline-block;
        background-color: ${props => props.ativo ? "#005081" : "#97A6B7"};
    `;

function Stepper({
    stepAtivo
}: {
    stepAtivo: number
}) {    

    return(
        <Flex gap="14px">
            <StyledDot ativo={stepAtivo === 1}></StyledDot>
            <StyledDot ativo={stepAtivo === 2}></StyledDot>
            <StyledDot ativo={stepAtivo === 3}></StyledDot>
            <StyledDot ativo={stepAtivo === 4}></StyledDot>
            <StyledDot ativo={stepAtivo === 5}></StyledDot>
        </Flex>        
    )
}

export default Stepper